import type { LocaleStrings } from './i18n';

const lt: LocaleStrings = {
    login_success: 'Prisijungta sėkmingai',
    password_reset_code_verified: 'Slaptažodžio nustatymo iš naujo kodas patvirtintas',
    password_reset_success: 'Slaptažodis sėkmingai nustatytas iš naujo',
    password_update_success: 'Slaptažodis sėkmingai atnaujintas',
    register_success: 'Užsiregistravote sėkmingai',
    user_update_success: 'Vartotojo profilis sėkmingai atnaujintas',
    all: 'Visos',
    allowed: 'Leidžiama',
    already_have_account: 'Jau turite paskyrą?',
    and: 'ir',
    back: 'atgal',
    cancel: 'Atšaukti',
    by_registering_agree: 'Registruodamiesi patvirtiname, kad sutinkate su CodeAcademy Online',
    change_password: 'pakeisti slaptažodį',
    code: 'Kodas',
    code_required: 'Kodas yra privalomas',
    create_group: 'Sukurti grupę',
    created_groups: 'Sukurtos grupės',
    confirm_new_password: 'Patvirtinkite naują slaptažodį',
    content: 'Turinys',
    course_code: 'Kurso kodas',
    course_illustration: 'kurso iliustracija',
    courses: 'Kursai',
    dashboard: 'Pagrindinis',
    didnt_receive_email: 'Negavote el. laiško?',
    dont_have_account: `Neturite paskyros?`,
    edit: 'Redaguoti',
    email_address: 'El. pašto adresas',
    email_address_must_be_from_codeacademy_domain: 'Turi būti galiojantis CodeAcademy el. pašto adresas',
    email_address_must_be_valid: 'El. pašto adresas turi būti validus',
    email_address_required: 'El. pašto adresas yra privalomas',
    enter_new_password_subtitle: 'Įveskite naują slaptažodį, kuris bus susietas su jūsų paskyra.',
    enter_new_password_title: 'Įveskite naują slaptažodį',
    error_fetching_courses: 'Gaunant kursus įvyko klaida.',
    error_fetching_lessons: 'Gaunant pamokas įvyko klaida.',
    error_fetching_modules: 'Gaunant modulius įvyko klaida',
    error_fetching_topic_content: 'Gaunant temos turinį įvyko klaida',
    error_fetching_topics: 'Gaunant temą įvyko klaida',
    evening: 'Vakaras',
    finish: 'Užbaigti pamoką',
    first_name: 'Vardas',
    first_name_required: 'Vardas yra privalomas',
    forgot_password: 'Pamiršote slaptažodį',
    forgot_your_password_details:
        'Įveskite su paskyra susietą el. pašto adresą ir el. paštu atsiųsime nuorodą slaptažodžiui nustatyti iš naujo.',
    forgot_your_password_title: 'Pamiršote slaptažodį?',
    hours: 'valandos',
    general: 'bendri',
    go_to_home: 'Grįžti į pagrindinį',
    group: 'Grupė',
    group_content: 'Grupės turinys',
    groups: 'Grupės',
    manage_group_content: 'Tvarkyti grupės turinį',
    manage_groups: 'Grupių valdymas',
    manage_roles: 'Rolių valdymas',
    activity_log: 'Veiksmų žurnalas',
    activity_log_hint:
        'Kas ir kada kūrė, keitė ar trynė grupes, studentus, roles ir susitikimus, siuntė laiškus. Įrašoma nuo žurnalo įjungimo; nepavykę veiksmai pažymėti.',
    activity_log_search: 'Ieškoti pagal grupę ar vardą',
    activity_log_person: 'Kas atliko',
    activity_log_no_people: 'Tokio žmogaus nėra',
    activity_log_action: 'Veiksmas',
    activity_log_all_actions: 'Visi veiksmai',
    activity_log_failed_only: 'Tik nepavykę',
    activity_log_refresh: 'Atnaujinti',
    activity_log_empty: 'Įrašų nėra.',
    activity_log_load_more: 'Rodyti senesnius',
    activity_log_failed: 'Nepavyko',
    activity_log_students_count: 'Studentų: {{count}}',
    activity_log_role: 'Rolė: {{role}}',
    activity_action_group_created: 'Sukurta grupė',
    activity_action_group_updated: 'Redaguota grupė',
    activity_action_group_deleted: 'Ištrinta grupė',
    activity_action_meeting_scheduled: 'Suplanuotas susitikimas',
    activity_action_meeting_deleted: 'Ištrintas susitikimas',
    activity_action_teams_synced: 'Sinchronizuota su Teams',
    activity_action_staff_notified: 'Išsiųstas laiškas dėstytojui ar kuratoriui',
    activity_action_lecturers_assigned: 'Priskirti dėstytojai',
    activity_action_curator_assigned: 'Priskirtas kuratorius',
    activity_action_students_added: 'Pridėti esami studentai',
    activity_action_statuses_verified: 'Patikrinti studentų statusai',
    activity_action_student_created: 'Sukurtas studentas',
    activity_action_student_updated: 'Redaguotas studentas',
    activity_action_student_deleted: 'Ištrintas studentas',
    activity_action_student_groups_changed: 'Pakeistos studento grupės',
    activity_action_role_assigned: 'Suteikta rolė',
    activity_action_role_removed: 'Atimta rolė',
    activity_action_role_reassigned: 'Pakeista rolė',
    activity_action_onboarding_emails_run: 'Paleistas laiškų siuntimas',
    activity_action_onboarding_email_sent: 'Išsiųstas pasisveikinimo laiškas',
    manage_users: 'Naudotojų valdymas',
    assign_lecturer: 'Priskirti dėstytoją',
    select_lecturer: 'Pasirinkite dėstytoją',
    assign_curator: 'Priskirti kuratorių',
    select_curator: 'Pasirinkite kuratorių',
    assign_courses: 'Priskirti kursus',
    assign_groups: 'Priskirti grupes',
    assign_role: 'Priskirti rolę',
    current_roles: 'Esamos rolės',
    role: 'Rolė',
    curator: 'Kuratorius',
    role_assigned_successfully: 'Rolė sėkmingai priskirta',
    user_not_found_for_role_assignment: 'Vartotojas nerastas. Rolę galima priskirti tik esamiems vartotojams.',
    multiple_users_found_provide_email:
        'Rasti keli vartotojai su tuo pačiu vardu ir pavarde. Įveskite el. paštą, kad parinktumėte teisingą vartotoją.',
    email_optional_for_role_assignment:
        'Neprivaloma. Reikalinga tik jei keli vartotojai turi tą patį vardą ir pavardę.',
    role_assign_only_existing_users:
        'Rolę galima priskirti tik vartotojams, kurie jau egzistuoja sistemoje. El. paštas neprivalomas, bet ' +
        'reikalingas, jei keli vartotojai turi tą patį vardą ir pavardę.',
    remove_role_confirmation: 'Ar norite pašalinti rolę „{{role}}“ šiam vartotojui: {{user}}?',
    groups_content: 'grupės turinį',
    groups_content_updates: 'Grupės turinys atnaujintas',
    admin: 'Administratorius',
    docs: 'Dokumentacija',
    docs_subtitle: 'Kaip naudotis Code Academy Online: rodomi tik jūsų rolei aktualūs puslapiai.',
    docs_search: 'Ieškoti dokumentacijoje',
    docs_no_results: 'Nieko nerasta. Pabandykite kitą žodį.',
    docs_on_this_page: 'Šiame puslapyje',
    docs_not_found: 'Šio dokumentacijos puslapio nėra arba jis jums nepasiekiamas.',
    docs_back: 'Į dokumentaciją',
    docs_group_start: 'Pradžia',
    docs_group_learning: 'Mokymasis',
    docs_group_chat: 'Code Academy AI',
    docs_group_teaching: 'Dėstytojams',
    docs_group_admin: 'Administravimas',
    docs_group_superadmin: 'Super administratoriams',
    chat_insights: 'Pokalbių boto statistika',
    chat_insights_subtitle: 'Code Academy AI naudojimo ir kokybės rodikliai — matomi tik super administratoriams.',
    chat_insights_tab_overview: 'Apžvalga',
    chat_insights_tab_topics: 'Temos',
    chat_insights_distinct_users: 'Skirtingi žmonės (viso)',
    chat_insights_distinct_users_today: 'Skirtingi žmonės šiandien',
    chat_insights_messages_today: 'Žinutės šiandien',
    chat_insights_rate_limited_today: 'Pasiekę dienos limitą šiandien',
    chat_insights_total_conversations: 'Pokalbių iš viso',
    chat_insights_total_messages: 'Žinučių iš viso',
    chat_insights_refusal_rate: '„Neaptarta“ dažnis',
    chat_insights_daily_breakdown: 'Kasdienis aktyvumas',
    chat_insights_chart_messages: 'Žinutės',
    chat_insights_chart_distinct_users: 'Skirtingi žmonės',
    chat_insights_top_topics: 'Apie ką klausiama (per laikotarpį)',
    chat_insights_top_topics_chart_label: 'Atsakymai',
    chat_insights_range: 'Laikotarpis',
    chat_insights_last_n_days: 'Paskutinės {{count}} dienos',
    chat_insights_data_from: 'Duomenys rodomi nuo',
    chat_insights_no_data_yet: 'Šiam laikotarpiui duomenų dar nėra.',
    chat_insights_notes: 'Testuotojų pastabos',
    chat_insights_notes_hint: 'Pokalbio žinutės, pradėtos žodžiu „pastaba“. Rodomos naujausios 200.',
    chat_insights_notes_empty: 'Pastabų dar nėra.',
    chat_insights_notes_question: 'Klausimas',
    chat_insights_notes_answer: 'Atsakymas',
    chat_insights_notes_local: 'lokaliai',
    chat_insights_positive_ratings: 'Teigiami įvertinimai',
    chat_insights_negative_ratings: 'Neigiami įvertinimai',
    chat_insights_web_answers: 'Atsakymai iš oficialios dokumentacijos',
    chat_insights_locked_topics: 'Klausimai apie neatidarytas temas',
    chat_insights_section_usage: 'Naudojimas',
    chat_insights_section_period: 'Per pasirinktą laikotarpį',
    chat_insights_answers: 'Atsakymai',
    chat_insights_handoffs: 'Pagalbos prašymai',
    chat_insights_handoffs_hint:
        'Vartotojai, paspaudę „Noriu kalbėti su žmogumi“. Susisiekite el. paštu ir pažymėkite prašymą išspręstu.',
    chat_insights_handoffs_empty: 'Prašymų dar nėra.',
    chat_insights_handoff_open: 'Atviras',
    chat_insights_handoff_resolved: 'Išspręstas',
    chat_insights_handoff_mark_resolved: 'Pažymėti išspręstu',
    chat_insights_handoff_reopen: 'Atidaryti iš naujo',
    chat_insights_handoff_transcript: 'Rodyti pokalbį',
    chat_insights_handoff_transcript_expired: 'Pokalbis nebepasiekiamas: praėjo 30 dienų arba jis nebuvo išsaugotas.',
    chat_insights_handoff_summary: 'Santrauka',
    chat_insights_handoff_no_summary: 'Santraukos nėra.',
    chat_insights_transcript_audit_note: 'Pokalbio peržiūra įrašoma į peržiūrų žurnalą.',
    chat_insights_close: 'Uždaryti',
    chat_insights_gaps: 'Turinio spragos',
    chat_insights_gaps_hint:
        'Paskutinių 7 dienų klausimai, į kuriuos medžiaga neatsakė arba kurie įvertinti neigiamai, ' +
        'sugrupuoti pagal temą.',
    chat_insights_gaps_generate: 'Sudaryti suvestinę',
    chat_insights_gaps_counts: 'Klausimų: {{total}} (neatsakyta: {{refused}}, įvertinta neigiamai: {{negative}})',
    chat_insights_gaps_empty: 'Šiam laikotarpiui spragų nerasta.',
    chat_insights_audit: 'Peržiūrų žurnalas',
    chat_insights_audit_hint: 'Kas ir kada peržiūrėjo pokalbių turinį.',
    chat_insights_audit_empty: 'Įrašų dar nėra.',
    chat_insights_audit_action_notes: 'Pastabų sąrašas',
    chat_insights_audit_action_handoffs: 'Pagalbos prašymų sąrašas',
    chat_insights_audit_action_transcript: 'Pokalbio peržiūra',
    chat_insights_audit_action_gaps: 'Turinio spragų suvestinė',
    chat_insights_refresh: 'Atnaujinti',
    home: 'Pagrindinis',
    incorrect_or_tampered_link: 'Neteisinga arba sugadinta nuoroda',
    internal_server_error: 'Vidinė serverio klaida',
    internal_server_error_description:
        'Įvyko klaida. Bandykite dar kartą vėliau arba susisiekite su sistemos administratoriumi.',
    lecturer: 'Dėstytojas',
    last_name: 'Pavardė',
    last_name_required: 'Pavardė yra privaloma',
    latest: 'Naujausia',
    lesson: 'Pamoka',
    lessons: 'Pamokos',
    link_to_login_text: 'Prisijungti',
    link_to_registration_text: 'Užsiregistruokite',
    login: `Prisijungti`,
    login_form_subtitle: `Įveskite savo prisijungimo duomenis žemiau.`,
    login_form_title: 'Prisijunkite prie CodeAcademy Online',
    login_greeting_title: `Sveiki sugrįžę!`,
    login_illustration: 'prisijungimo iliustracija',
    login_with_google: `Prisijungti su Google`,
    logout: `Atsijungti`,
    module_code: 'Modulio kodas',
    module_illustration: 'modulio iliustracija',
    modules: 'Moduliai',
    morning: 'Rytas',
    name: 'Pavadinimas',
    new_password: 'Naujas slaptažodis',
    new_password_helper_text: 'Slaptažodis turi būti bent 8 simbolių',
    new_password_required: 'Reikalingas naujas slaptažodis',
    next: 'Sekanti tema',
    no_modules_for_this_group: 'Šiai grupei nėra priskirtų modulių.',
    no_courses_found: 'Nerasta jokių kursų',
    no_lessons_found: 'Nerasta jokių pamokų',
    no_modules_found: 'Nerasta jokių modulių',
    no_results_for: 'Rezultatų nerasta',
    no_results_helper_text: 'Pabandykite patikrinti ar nėra rašybos klaidų, arba naudokite pilnus žodžius.',
    no_topics_found: 'Nerasta jokių temų',
    not_found: 'Rezultatų nerasta',
    notifications: 'pranešimai',
    old_password: 'Senas slaptažodis',
    old_password_required: 'Reikalingas senas slaptažodis',
    owners: 'Savininkai',
    open_lessons_helper_text: 'Tuščia reikšmė reiškia, kad modulis yra nematomas',
    opened_lessons: 'Atidarytos pamokos',
    open: 'Atidaryti',
    page_not_found: 'Puslapis nerastas',
    page_not_found_description: 'Atsiprašome, nepavyko rasti puslapio, kurio ieškote. Galbūt neteisingai įvedėte URL?',
    password: 'Slaptažodis',
    password_must_be_at_least_8_characters: 'Slaptažodis turėtų būti per 8 simbolių',
    password_must_match: 'Slaptažodžiai turi sutapti',
    password_required: 'Slaptažodis yra privalomas',
    please_check_your_email: 'Prašome patikrinti savo el. paštą.',
    please_try_again_or_contact_admin:
        'Pabandykite dar kartą vėliau. Klaidai nepradingus - susisiekite su sistemos administratoriumi.',
    privacy_policy: 'Privatumo Politika',
    redirecting: 'Nukreipiama',
    register: `Registruotis`,
    register_illustration: 'registracijos iliustracija',
    registration_form_subtitle: 'Išskirtinai skirta CodeAcademy ir CodeAcademy College studentams.',
    registration_form_title: 'Užsiregistruokite prie CodeAcademy Online',
    registration_greeting_title: `Internetinė švietimo platforma, skirta padėti mūsų studentams`,
    remember_me: 'Prisiminti mane',
    confirm_email: 'Patvirkinkite savo el. pašto adresą',
    resend_email: 'Iš naujo siųsti el. laišką',
    reset_password: 'Atstatyti slaptažodį',
    reset_password_greeting_title: 'Atstatykite prisijungimą',
    reset_password_illustration: 'slaptažodžio nustatymo iš naujo iliustracija',
    save_changes: 'Išsaugoti pakeitimus',
    search_groups: 'Ieškoti grupių',
    search_by_name_or_code: 'Ieškoti pagal pavadinimą ar kodą',
    search_by_name: 'Ieškoti pagal vardą ar pavardę',
    sent_confirmation_email_to: 'Išsiuntėme patvirtinimo el. laišką adresu',
    set_password: 'Nustatyti slaptažodį',
    something_went_wrong: 'Įvyko klaida.',
    add_existing_student: 'Pridėti esamą',
    verify_provisioning: 'Patikrinti statusus',
    status_fields_updated: 'Atnaujinti laukai',
    status_drift_found: 'Rasta neatitikimų',
    status_unverifiable: 'Nepavyko patikrinti',
    status_already_up_to_date: 'Viskas jau atitinka',
    teams_check_unavailable: 'Nepavyko patikrinti Teams narystės',
    meeting_check_unavailable: 'Nepavyko patikrinti pakvietimo į susitikimą',
    ms_provisioning_disabled: 'Microsoft paskyrų kūrimas išjungtas konfigūracijoje.',
    students_enrolled: 'Studentai pridėti į grupę',
    students_skipped: 'Praleista studentų',
    existing_student_move_hint: 'Pasirinkti studentai perkeliami į šią grupę ir pašalinami iš ankstesnės.',
    forbidden_access: 'Neturite teisių atlikti šį veiksmą.',
    staff_user_not_found: 'Pasirinktas vartotojas nerastas.',
    user_does_not_hold_required_role: 'Pasirinktas vartotojas neturi reikiamos rolės.',
    no_students_enrolled: 'Nepavyko pridėti nė vieno studento.',
    too_many_students_per_request: 'Vienu metu galima pasirinkti daugiausiai 50 studentų.',
    chat_title: 'Code Academy AI',
    chat_intro_header: 'Prieš pradedant',
    chat_intro_title: 'Apie Code Academy AI',
    chat_intro_body_1:
        'Code Academy AI atsako į klausimus remdamasis jūsų kurso medžiaga — paskaitomis, konspektais ir ' +
        'temomis, prie kurių turite prieigą.',
    chat_intro_body_2:
        'Jis atsako tik pagal šią medžiagą. Jei tema neaptarta, jis taip ir pasakys, o ne bandys atspėti atsakymą.',
    chat_intro_body_3:
        'Atsako ta kalba, kuria rodoma svetainė. Pokalbiai 30 dienų saugomi Code Academy serveryje, ' +
        'todėl juos galite tęsti ir kitame įrenginyje.',
    chat_consent_label:
        'Sutinku, kad mano žinutės būtų siunčiamos DI paslaugai atsakymui sugeneruoti ' +
        'ir 30 dienų saugomos Code Academy serveryje, kad galėčiau pokalbius tęsti vėliau.',
    chat_intro_continue: 'Tęsti',
    chat_greeting: 'Sveiki! Kaip galiu padėti?',
    chat_scope_title: 'Galite klausti apie:',
    chat_scope_toggle: 'Temos',
    chat_code_copy: 'Kopijuoti kodą',
    chat_code_copied: 'Nukopijuota',
    chat_quota_left_one: 'Šiandien liko {{n}} žinutė',
    chat_quota_left_few: 'Šiandien liko {{n}} žinutės',
    chat_quota_left_many: 'Šiandien liko {{n}} žinučių',
    chat_quota_used_up: 'Šiandienos žinučių limitas išnaudotas. Jis atsinaujins rytoj.',
    chat_scope_module_question: 'Kokias temas apima modulis „{module}“?',
    chat_rate_limited: 'Pasiekėte šiandienos žinučių limitą. Pabandykite rytoj.',
    chat_session_conflict: 'Šį pokalbį reikia paleisti iš naujo — parašykite žinutę dar kartą.',
    chat_not_in_pilot: 'Šis pagalbininkas dar nepasiekiamas jūsų grupei.',
    chat_placeholder: 'Rašykite žinutę…',
    chat_typing: 'Rašoma…',
    chat_searching_docs: 'Ieškoma oficialioje dokumentacijoje…',
    chat_new_conversation: 'Naujas pokalbis',
    chat_history: 'Pokalbių istorija',
    chat_back_to_conversation: 'Grįžti į pokalbį',
    chat_untitled: 'Naujas pokalbis',
    chat_delete_title: 'Pašalinti šį pokalbį?',
    chat_delete_body: 'Pokalbis bus ištrintas iš šio įrenginio ir iš Code Academy serverio.',
    chat_delete_confirm: 'Pašalinti',
    chat_select_all: 'Žymėti visus',
    chat_delete_selected: 'Pašalinti pažymėtus',
    chat_delete_many_title: 'Pašalinti pažymėtus pokalbius ({{n}})?',
    chat_delete_many_body: 'Pokalbiai bus ištrinti iš šio įrenginio ir iš Code Academy serverio.',
    chat_delete_server_failed: 'Pokalbio nepavyko ištrinti iš serverio. Bandykite dar kartą vėliau.',
    chat_history_loading: 'Įkeliamas pokalbis',
    chat_empty_hint: 'Pradėkite naują pokalbį.',
    chat_consent_required: 'Prieš tęsiant patvirtinkite sutikimą.',
    chat_rate_up: 'Naudingas atsakymas',
    chat_rate_down: 'Nenaudingas atsakymas',
    chat_handoff_open: 'Noriu kalbėti su žmogumi',
    chat_handoff_title: 'Perduoti klausimą komandai',
    chat_handoff_body: 'Code Academy komanda gaus trumpą šio pokalbio santrauką ir su jumis susisieks el. paštu.',
    chat_handoff_comment: 'Ką dar norėtumėte pridurti? (nebūtina)',
    chat_handoff_send: 'Siųsti',
    chat_handoff_sent: 'Prašymas išsiųstas. Su jumis susisieks komanda.',
    chat_handoff_limit: 'Šiandien išsiuntėte jau daug prašymų. Pabandykite rytoj.',
    sorted_ascending: 'rūšiuojama didėjančia tvarka',
    sorted_descending: 'rūšiuojama mažėjančia tvarka',
    terms_of_service: 'Paslaugų Teikimo Sąlygomis',
    too_long: 'Per ilgas!',
    too_short: 'Per trumpas!',
    topic: 'Tema',
    topics: 'Temos',
    unable_to_logout: `Nepavyko atsijungti!`,
    update_photo: 'Atnaujinti nuotrauką photo',
    upload_photo: 'Įkelti nuotrauką',
    user: 'Vartotojas',
    user_management: 'Vartotojo valdymas',
    verify: 'Patvirtinti',
    verify_code_subtitle: 'Įveskite 6 simbolių patvirtinimo kodą, kuris buvo bendrinamas su jūsų grupe',
    verify_code_title: 'Įveskite grupės kodą',
    verify_email_and_code_illustration: 'patvirtinkite el. pašto adresą ir kodo iliustracija',
    verify_email_subtitle_part_1: 'Išsiuntėme Jums patvirtinimo nuorodą',
    verify_email_subtitle_part_2: 'spustelėkite šią nuorodą, kad patvirtintumėte savo el. pašto adresą.',
    verify_email_title: 'Patikrinkite savo el. paštą!',
    view_course: 'Žiūrėti kursą',
    view_lesson: 'Žiūrėti pamoką',
    view_module: 'Žiūrėti modulį',
    your_account: 'Jūsų paskyra',
    lastest_lesson: 'Naujausia pamoka',
    all_lessons: 'Visos pamokos',
    open_lessons: 'atidaryti pamokas',
    settings: 'nustatymai',
    language: 'kalba',
    language_preference: 'Kalbos nuostatos',
    language_preference_saved: 'Kalbos pasirinkimas išsaugotas',
    language_required: 'Kalbos pasirinkimas yra privalomas',
    'auth/email-already-in-use': 'Pateiktą el. paštą jau naudoja esamas vartotojas',
    'auth/expired-action-code': 'Nuorodos galiojimo laikas baigėsi',
    'auth/invalid-action-code': 'Nuoroda sugadinta arba jau buvo panaudota anksčiau',
    'auth/invalid-email': 'Pateiktas el. pašto adresas neteisingas',
    'auth/invalid-user-token': 'Naudotojo prieigos raktas neteisingas',
    'auth/user-disabled': 'Vartotojas yra užblokuotas',
    'auth/user-not-found': 'Vartotojas nerastas. Jeigu jungiatės pirmą kartą, užsiregistruokite.',
    'auth/user-token-expired': 'Naudotojo prieigos rakto galiojimo laikas baigėsi',
    'auth/weak-password': 'Slaptažodis per silpnas',
    'auth/wrong-password': 'Neteisingi prisijungimo duomenys',
    'auth/invalid-group-code': 'Neteisingas grupės kodas',
    'db/no-document': 'Įrašų nerasta',
    last_updated: 'Paskautinį kartą atnaujinta',
    by: '|',
    phone_number_is_not_valid: 'Telefono numeris nėra validus',
    phone_number: 'Telefono numeris',
    save: 'Išsaugoti',
    fill_data: 'Įveskite žemiau esančius duomenis',
    inventory: 'Inventorius',

    // Inventory-specific
    add_inventory: 'Pridėti inventorių',
    inventory_form: 'Inventoriaus forma',
    edit_inventory: 'Redaguoti inventorių',
    person_name: 'Vardas',
    computer_name: 'Kompiuteris',
    serial_number: 'Serijos numeris',
    company_label: 'Įmonė',
    category_label: 'Kategorija',
    returning_time: 'Grąžinimo data',
    issue_date: 'Išdavimo data',
    now: 'Dabar',
    notes: 'Pastabos',
    loading: 'Kraunama...',
    sort_by: 'Rikiuoti pagal',
    created: 'Sukurta',
    person: 'Vardas',
    item: 'Inventorius',
    return_time: 'Grąžinimo data',
    issued: 'Išduota',
    return_action: 'Grąžinti',
    returning: 'Grąžinama...',
    asc: 'Didėjančiai',
    desc: 'Mažėjančiai',
    delete_item_confirmation: 'Ar tikrai norite ištrinti šį inventorių?',
    delete: 'Ištrinti',
    free: 'Laisvas',
    search_name_or_item: 'Ieškoti vardo ar inventoriaus',

    // Personal
    scores: 'Rezultatai',
    no_scores_yet: 'Rezultatų kolkas nėra',

    best_scores: 'Geriausi rezultatai',

    // Attendance
    view_attendance: 'Peržiūrėti lankomumą',
    attendance: 'Lankomumas',
    attendance_for_group: 'Grupės lankomumas',
    student_name: 'Studento vardas',
    total_hours: 'Iš viso valandų',
    date: 'Data',
    start_date: 'Pradžios data',
    end_date_required: 'Pabaigos data yra privaloma',
    end_date: 'Pabaigos data',
    lecture_cycle: 'Paskaitų ciklas',
    monday_to_friday: 'Pirmadienis - Penktadienis',
    monday_to_thursday: 'Pirmadienis - Ketvirtadienis',
    custom_cycle: 'Pasirinktos dienos',
    lecture_days: 'Paskaitų dienos',
    lecture_days_required: 'Pasirinkite bent vieną paskaitų dieną',
    lecture_time_from: 'Paskaitų laikas nuo',
    lecture_time_to: 'Paskaitų laikas iki',
    lecture_time_both_required: 'Nurodykite tiek paskaitų pradžios, tiek pabaigos laiką',
    monday: 'Pirmadienis',
    tuesday: 'Antradienis',
    wednesday: 'Trečiadienis',
    thursday: 'Ketvirtadienis',
    friday: 'Penktadienis',
    load_students: 'Užkrauti studentus',
    refresh: 'Atnaujinti',
    students_in_group: 'Studentai grupėje',
    add_student_to_group: 'Pridėti studentą į grupę',
    add_student: 'Pridėti studentą',
    group_created_successfully: 'Grupė sėkmingai sukurta',
    group_assigned_to_lecturer: 'Grupė sėkmingai priskirta dėstytojui',
    group_assigned_to_curator: 'Grupė sėkmingai priskirta kuratoriui',
    group_updated_successfully: 'Grupė sėkmingai atnaujinta',
    student_added_successfully: 'Studentas sėkmingai pridėtas',
    student_updated_successfully: 'Studentas sėkmingai atnaujintas',
    student_deleted_successfully: 'Studentas sėkmingai ištrintas',
    student_groups_updated: 'Studento grupės atnaujintos',
    no_groups_created: 'Dar nėra sukurtų grupių',
    no_users_found: 'Naudotojų nerasta',
    group_end_before_start: 'Pabaigos data negali būti ankstesnė už pradžios datą.',
    group_code_exists: 'Grupė su tokiu kodu jau yra. Bandykite sukurti dar kartą.',
    group_invalid_lecture_time: 'Neteisingas paskaitų laikas. Naudokite formatą VV:MM.',
    group_invalid_lecture_cycle: 'Pasirinkite paskaitų ciklą.',
    group_invalid_date: 'Neteisinga data.',
    group_invalid_courses: 'Neteisingai pasirinkti kursai.',
    group_unknown_courses: 'Kai kurių pasirinktų kursų nebėra. Atnaujinkite puslapį ir pasirinkite kursus iš naujo.',
    group_not_found: 'Grupė nerasta. Ji galėjo būti ištrinta: atnaujinkite puslapį.',
    student_login_email: 'Prisijungimo el. paštas: {{email}}',
    student_email_in_group: 'Studentas su tokiu el. pašto adresu jau yra šioje grupėje.',
    student_fields_required: 'Įveskite studento vardą, pavardę ir el. pašto adresą.',
    student_not_found: 'Studentas nerastas. Jis galėjo būti ištrintas: atnaujinkite puslapį.',
    start_date_required: 'Pradžios data yra privaloma',
    students_list: 'Studentų sąrašas',
    hide_students: 'Slėpti studentus',
    edit_student: 'Redaguoti studentą',
    delete_student_warning: 'Šis veiksmas negrįžtamai ištrina studentą.',
    delete_student_instruction: 'Įveskite esamą studento el. paštą (arba ID), kad patvirtintumėte trynimą:',
    student_confirmation: 'Studento patvirtinimas',
    group_deleted_successfully: 'Grupė sėkmingai ištrinta',
    delete_group_title: 'Ištrinti grupę',
    delete_group_warning:
        'Grupė bus ištrinta negrįžtamai. Studentų paskyros liks, jie tik bus pašalinti iš šios grupės.',
    delete_group_instruction: 'Įveskite grupės kodą, kad aktyvuotumėte trynimą:',
    group_code_confirmation: 'Grupės kodo patvirtinimas',
    delete_group_confirm: 'Ištrinti grupę negrįžtamai',
    group_details: 'Grupės informacija',
    subjects: 'Temos',
    no_attendance_data: 'Lankomumo duomenų nėra',
    error_fetching_attendance: 'Klaida gaunant lankomumo duomenis',
    loading_attendance: 'Kraunamas lankomumas...',
    hours_abbreviation: 'val.',
    export_to_excel: 'Atisiųsti',
    total_days: 'Iš viso dienų',
    active_on_top: 'Aktyvios viršuje',
    ms_teams_created: 'Teams sukurta',
    ms_teams_pending: 'Teams kuriama',
    ms_teams_failed: 'Teams klaida',
    ms_teams_not_provisioned: 'Nėra Teams grupės',
    create_ms_teams_group: 'Sukurti Teams grupę',
    retry_ms_teams_creation: 'Konvertuoti į komandą',
    ms_teams_provisioned_successfully: 'MS Teams grupė sėkmingai sukurta',
    ms_teams_provision_failed:
        'Nepavyko sukurti MS Teams grupės. Patikrinkite, ar serveris veikia, ir bandykite dar kartą.',
    ms_teams_conversion_failed:
        'MS Teams grupė sukurta, bet nepavyko konvertuoti į komandą. Bandykite dar kartą vėliau.',
    ms_teams_group_already_exists: 'MS Teams grupė su tokiu pavadinimu jau egzistuoja.',
    ms_teams_group_creation_failed: 'Nepavyko sukurti MS Teams grupės.',
    assign: 'Priskirti',
    lecturer_assigned_and_notified: 'Dėstytojas priskirtas ir pranešimas išsiųstas',
    curator_email_sent: 'Kuratoriaus pranešimas išsiųstas',
    group_has_no_curator: 'Grupei nepriskirtas kuratorius.',
    lecturer_email_sent: 'Dėstytojo pranešimas išsiųstas',
    send: 'Siųsti',
    send_email: 'Siųsti laišką',
    send_onboarding_email: 'Siųsti pasisveikinimo laišką',
    resend_onboarding_email: 'Siųsti pasisveikinimo laišką dar kartą',
    onboarding_email_sent: 'Laiškas išsiųstas',
    send_all_emails: 'Išsiųsti laiškus',
    schedule_meeting: 'Suplanuoti susitikimą',
    reschedule_meeting: 'Perskirstyti susitikimą',
    meeting_scheduled_successfully: 'Pasikartojanti paskaita suplanuota',
    meeting_deleted_successfully: 'Pasikartojanti paskaita ištrinta',
    delete_meeting: 'Ištrinti susitikimą',
    ms_teams_meeting_creation_failed: 'Nepavyko sukurti pasikartojančio susitikimo.',
    ms_teams_meeting_deletion_failed: 'Nepavyko ištrinti esamo Teams susitikimo. Bandykite dar kartą vėliau.',
    sync_team_members: 'Sinchronizuoti narius',
    workflow_need_team_first: 'Pirmiausia sukurkite Teams grupę',
    workflow_need_lecturer_first: 'Pirmiausia priskirkite dėstytoją grupei',
    workflow_need_ms_accounts: 'Visi studentai turi turėti MS paskyras prieš sinchronizaciją',
    workflow_need_sync_first: 'Pirmiausia sinchronizuokite visus narius į komandą',
    notify_lecturer_failed: 'Dėstytojas priskirtas, bet nepavyko išsiųsti pranešimo',
    lecturer_has_no_email: 'Dėstytojui ar kuratoriui nenurodytas el. pašto adresas',
    loading_students: 'Kraunami studentai...',
    student_with_same_name_already_exists:
        'Studentas su tokiu pat vardu ir pavarde jau egzistuoja. Naudokite kitą vardą arba kreipkitės į ' +
        'administratorių.',
    unsaved_changes_title: 'Neišsaugoti pakeitimai',
    discard_changes: 'Neišsaugoti',
    unsaved_changes_message:
        'Grupės informacija buvo pakeista, bet neišsaugota. Išsaugokite pakeitimus arba jų atsisakykite.',
};

export default lt;
